import { render, staticRenderFns } from "./CarrierList.vue?vue&type=template&id=f3c7127c&scoped=true"
import script from "./CarrierList.vue?vue&type=script&lang=js"
export * from "./CarrierList.vue?vue&type=script&lang=js"
import style0 from "./CarrierList.vue?vue&type=style&index=0&id=f3c7127c&prod&lang=scss"
import style1 from "./CarrierList.vue?vue&type=style&index=1&id=f3c7127c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c7127c",
  null
  
)

export default component.exports